import React from 'react';
import { CreatePageFormTemplate } from './CreatePageFormTemplate';
import {
  Form,
  HiddenParam, RadioParam,
  SelectParam,
  SonForm,
  TextAreaParam,
  TextParam,
  UrlParam,
  useForm,
} from '../../../../_lib/Form2';
import { DateRangeParam } from '../../../../_lib/Form2/types/DateRangeParam';
import { FieldSet } from '../../../../_lib/Form2/types/FieldSet';
import { NestedParam } from '../../../../_lib/Form2/types/NestedParam';
import { ImageFileParam } from '../../../../_lib/Form2/types/FileUploadParam';
import useRedirect from '../../../../hooks/useRedirect';
import { TeamRoomAdmissionTypeOptions } from './partials/TeamroomFormTemplate';
import { useHtmlValidId } from '../../../../hooks/useHtmlValidId';

export type CreatePageSonForm = SonForm<
  TextAreaParam<'teaserText'>
  | UrlParam<'url'>
  | UrlParam<'conferenceRoomUrl'>
  | TextParam<'name'>
  | TextAreaParam<'additionalInfo'>
  | TextParam<'location'>
  | HiddenParam<'teamroomOnlyRequested'>
  | SelectParam<'teamroomAdmissionType', TeamRoomAdmissionTypeOptions>
  | SelectParam<'initialReadRestriction'>
  | DateRangeParam<'daterange'>
  | FieldSet<'pageTypes', RadioParam<'pageType'>>
  | NestedParam<'imageuploadparams', 'imageupload',
    TextParam<'alt'> | TextParam<'copyright'> | ImageFileParam<'image'>>>;

export type CreatePageFormProps = {
  form: CreatePageSonForm
};

/** Renders the form for creating content, pages etc. in PageManagement.
 *
 * The form has 3 sections similar to the navigation. The sections have params
 * themselves which are rendered as radio buttons.
 * When the user selects one of them and advances to the next tab or clicks 'next',
 * additional form paramaters for the corresponding radio button are fetched.
 */
export function CreatePageForm({ form }: CreatePageFormProps) {
  const id = useHtmlValidId();
  const [startRedirect] = useRedirect();
  const { formProps, fetchState, params } = useForm({ form, onSuccess: (value) => {
    if (value.data.url) {
      startRedirect(value.data.url);
    }
  } });

  return (
    <Form {...formProps} id={`page-create-form-${id}`} modifier="no-padding">
      <CreatePageFormTemplate
        params={params}
        fetchState={fetchState}
      />
    </Form>
  );
}
